import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `workflowKey` is the stable key of the proposed group, the same one `FacilityWorkflowView.key` carries. */
class OpenWorkflowRun {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly workflowKey: string,
	) {
		Object.freeze(this);
	}

	toJSON(): Record<string, unknown> {
		return { workflowKey: this.workflowKey };
	}
}

export default OpenWorkflowRun;
